module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/ogp-ad4c5d85f43d14abde38ef6f701c75f5.png";